// import React from 'react';
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// import frenchfries from "../assests/img/SliderImages/yum-banner-1.jpg";
import frenchfries from "../assests/img/SliderImages/yum-banner-1.png";
import potatoeswedges from "../assests/img/SliderImages/yum-banner-2.jpg";

import { useLocation, useParams } from 'react-router-dom';
import blueyumwayseasmith from "../assets/img/blueyumwayseasmith.png";
import aboutbannerx10 from "../assets/img/aboutbannerX10.png";
import { Link } from 'react-router-dom';
import year_title_bg from '../assets/img/update_2/bg/year_title_bg.svg'
import year_title_bg51 from '../assets/img/update_2/bg/year_title_bg51.svg'
import bgbanner2 from '../assets/img/update_2/bg/bannerbg2.png'
import mapx1 from "../assets/img/mapx1.jpg";
import mapx444 from "../assets/img/mapx444.jpg";
import mapx444yum from "../assets/img/mapx444yum.png";
import potatoo from "../assets/img/potatoo2.png";
import potatoo1 from "../assets/img/potatoo1.png";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import about_6_1 from "../assets/img/update_2/normal/about_6_1.png";
import dishround from "../assets/img/update_2/normal/dishround.png";
import roundpotato from "../assets/img/update_2/normal/roundedpotato.png";
import contractfarm01 from "../assets/img/update_2/icon/contractfarm01.jpg";
import farmicon1 from "../assets/img/update_2/icon/farmicon1.svg";
import farm111 from "../assets/img/update_2/icon/farm111.jpg";
import farming222 from "../assets/img/update_2/icon/farming222.jpg";
import consistent01 from "../assets/img/update_2/icon/consistent01.jpg";
import consistenet111 from "../assets/img/update_2/icon/consistenet111.jpg";
import consistent222 from "../assets/img/update_2/icon/consistent222.jpg";
import quick01 from "../assets/img/update_2/icon/quick01.jpg";
import quick111 from "../assets/img/update_2/icon/quick111.jpg";
import quick222 from "../assets/img/update_2/icon/quick222.jpg";
import longshelf01 from "../assets/img/update_2/icon/longshelf01.jpg";
import longshelf111 from "../assets/img/update_2/icon/longshlef111.jpg";
import longshelf222 from "../assets/img/update_2/icon/longshelf222.jpg";
import tiger01 from "../assets/img/update_2/icon/tiger01.jpg";
import proudlymade111 from "../assets/img/update_2/icon/proudlymade111.jpg";
import tiger222 from "../assets/img/update_2/icon/tiger222.jpg";
import flexibility01 from "../assets/img/update_2/icon/flexibility01.jpg";
import flexibility111 from "../assets/img/update_2/icon/fexibility111.jpg";
import flexibility222 from "../assets/img/update_2/icon/flexibility222.jpg";
import testicardimg from "../assets/img/update_2/normal/testi-card_img.png";
// import abb from "../assets/img/update_2/normal/abb.png";
import abb1 from "../assets/img/update_2/normal/mission1.png";
import exhibition from "../assets/img/update_2/normal/exhibition.png";
// import abb from "../assets/img/update_2/normal/abb.mp4";
import qualitydrivenupdated1 from "../assets/img/update_2/normal/qualitydrivenupdated1.jpg";
import mission1 from "../assets/img/update_2/normal/mission1.png";
import vision1 from "../assets/img/update_2/normal/vision1.png";
import customerfocuedupdated1 from "../assets/img/update_2/normal/customerfocusedupdated1.jpg";
import td11 from "../assets/img/update_2/normal/td11.jpg";
import backwardintegration1 from "../assets/img/update_2/normal/backwardintegration1.png";
import backint from "../assets/img/update_2/normal/backint.png";
import bgfriesupdated from "../assets/img/update_2/normal/bgfriesupdated.jpg";
import testicardshape from "../assets/img/update_2/normal/testi-card_shape_1.png";
import testicardshapeimg from "../assets/img/update_2/normal/testi-card_shape_2.png";
import potatoban1 from "../assets/img/potatoban1.png";
import header_exhibition from "../assets/img/header_exhibition.png";

import shrimpovingimgx1 from "../assets/img/update_2/normal/shrimpmovingimgx1.png";
import potatosmovingimgx1 from "../assets/img/update_2/normal/potatomovingimgx1.png";
import HoveredMap from '../components/HoveredMap';
import certifications6 from "../assets/img/certifications7.png";
import certifications4 from "../assets/img/certifications8.png";    
import feature_bg_51 from "../assets/img/update_2/bg/feature_bg_51.jpg"
import s1 from "../assets/img/update_2/normal/s1.png";
import s2 from "../assets/img/update_2/normal/s2.png";
import s3 from "../assets/img/update_2/normal/s3.png";
import s4 from "../assets/img/update_2/normal/s4.png";
import s5 from "../assets/img/update_2/normal/s5.png";
import s6 from "../assets/img/update_2/normal/s6.png";
import s7 from "../assets/img/update_2/normal/s7.png";
import s8 from "../assets/img/update_2/normal/s8.png";
import Footer from './footer';


const Exhibition = (props) => {
    const location = useLocation();

    useEffect(() => {
        const { hash } = location;
        if (hash) {
            const id = hash.substring(1);
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }, [location]);




   
  
    return (


        <div>
            <div classNameName="d-none d-md-block">
                <div id="slider" classNameName="ls-wp-container fitvidsignore hero-6 th-hero-carousel"
                    style={{ margin: '0 auto' }}>


                    <div classNameName="ls-slide" data-ls="duration:5000; kenburnsscale:1.2;">
                        <div className="infrastructure-name">
                            <div style={{ marginTop: "25px" }}>
                                <ul style={{ listStyleType: 'none', padding: 20 }}>
                                    <li><h1 style={{ margin: 0, padding: 0 ,fontFamily: 'helvetica', color: 'white' }}>INTERNATIONAL EXHIBITION</h1></li>
                                    <li>
                                        <Link to="/home" style={{ color: 'white', padding: 4 }}><span className="homeclass" style={{ fontFamily: 'helvetica' }}>Home</span> &nbsp;</Link>
                                        <span style={{ color: 'white' }}>&gt; &nbsp;<span className="redname" style={{ fontFamily: 'helvetica', color: '#F0B323',color: '#0f1138' }}>International Exhibition</span></span>
                                        {/* <p className="redname" style={{ fontFamily: 'helvetica', color: '#0f1138',width:'50%' }}><b><i>"We don’t just manufacture food. We preserve love, flavour, and connection — passed down over centuries. YUMWAY is built for the ones who give love through food but also deserve a seat beside it. From 1805 to now, the only thing we’ve changed is how fast we can serve it."</i></b></p> 
                                        <span className="redname" style={{ fontFamily: 'helvetica', color: 'white' }}><b>— Karan Bhatia, Founder, YUMWAY</b></span>                                   */}
                                    </li>
                                </ul>

                            </div>

                        </div>
                        <img
                            width="2000"
                            height="435"
                            // src={aboutbannerx10}
                            src={header_exhibition}
                            className="ls-l ls-img-layer factory"
                            alt="image"
                            decoding="async"
                            style={{
                                fontSize: '36px',

                                color: '#000',
                                stroke: '#000',
                                strokeWidth: '0px',
                                textAlign: 'right',
                                fontStyle: 'normal',
                                textDecoration: 'none',
                                textTransform: 'none',
                                fontWeight: '400',
                                letterSpacing: '0px',
                                backgroundPosition: '0% 0%',
                                backgroundRepeat: 'no-repeat',
                                backgroundClip: 'border-box',
                                overflow: 'visible',
                                left: '0px',
                                top: '107px',
                                WebkitBackgroundClip: 'border-box'
                            }}
                            data-ls="offsetxin:500; durationin:600; delayin:100; easingin:easeOutBack; rotatein:80; bgcolorin:transparent; colorin:transparent;"
                        />

                    </div>



                </div>
            </div>


            <div class="about-sec overflow-hidden pb-5">
                <div class="container">

                    <div class="row">


                    </div>
                </div>
            </div>


            <div class="about-sec overflow-hidden pb-5">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-7 order-1 order-xl-1" style={{ marginTop: "0px" }}>
                            <div class="title-area mb-30 text-center text-xl-start">
                                <span class="sub-title" style={{ fontFamily:'helvetica' }}><span style={{color:"#F0B323"}}>Past Exhibitions That Shaped Our Export Legacy </span></span>
                                <h2 class="text-uppercase" style={{ fontFamily:'helvetica',color:'#0f1138 !important'}}>
                                    Showcasing India’s Frozen Food Excellence, One Booth at a Time</h2>
                            </div>
                            {/* <p class="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica',fontWeight:'600' }}>
                            One of India’s Most Trusted Frozen Food Brands — Rooted in Legacy, Loved Worldwide 
                            </p> */}
                            <p class="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                            We’ve proudly represented <strong>India’s clean-label frozen food legacy</strong> at the world’s most prestigious food and beverage exhibitions. These platforms have not only celebrated our products — but also <strong>strengthened our relationships with importers, HoReCa buyers, and bulk foodservice distributors</strong> from across continents.
                            </p>
                            <p class="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                           As a trusted <strong>frozen French fries exporter from India,</strong> our presence at global exhibitions reinforces YUMWAY’s role as a <strong>top frozen potato exporter,</strong> continuously engaging with <strong>regional distributors, white-label partners, and retail procurement heads.</strong>
                            </p>  
                            <p class="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                           Our exhibits have helped us build long-term partnerships with importers, <strong>HoReCa buyers</strong>, and retail distributors across <strong>Japan, Qatar, Saudi Arabia, Israel, and more.</strong>
                            </p>                                  

                                                                                                                                            
                            {/* <div class="checklist style4 mb-25" style={{ fontFamily:'helvetica' }}>
                                <ul>
                                    <li>Quality Assurance</li>
                                    <li>Heritage and Legacy</li>
                                    <li>Diverse Product Line</li>
                                    <li>Established Compliance</li>
                                </ul>
                            </div> */}
    

                            {/* <div className="text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <Link to="/about" className="th-btn rounded-2" style={{ fontFamily:'helvetica',background:"#F0B323"}}>See Details<i className="fa-solid fa-arrow-right ms-2"></i></Link>
                            </div> */}
                        </div>
                        {/* <div class="col-xl-5 order-2 order-xl-2 mt-xl-0" style={{ marginTop: "500px" }}> */}
                        <div class="col-xl-5 order-2 order-xl-2 " style={{ marginTop: "40px" }}>
                            <div class="testi-card-img " style={{marginLeft:'0px'}}>
                                {/* <div class="img1"> */}
                                    <img src={exhibition} alt="Image" />
                                    {/* <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    // controls
                                    className="background-video"
                                    >
                                    <source src={abb} type="video/mp4" />
                                    Your browser does not support the video tag.
                                    </video> */}
                                    {/* <img src={testicardimg} alt="Image" /> */}
                                {/* </div> */}
                                {/* <div class="shape1">
                                    <img src={testicardshape} alt="Image" />
                                </div>
                                <div class="shape2">
                                    <img src={testicardshapeimg} alt="Image" />
                                </div>
                                <div class="shape3">
                                    <img src={dishround} alt="Image" />
                                </div>
                                <div class="shape44x">
                                    <img src={roundpotato} alt="Image" />
                                </div> */}
                            </div>
                        </div>

                    </div>
                </div>
            </div>                       

            <section class="space-bottom contact-form-sec mt-0">
                <div class="container">
                    <div class="reservation-area"style={{ backgroundImage: `url(${feature_bg_51})`, position: 'relative', top: '27px' }}>
                        <div class="title-area mb-0 text-center ">
                            <span class="sub-title" style={{ fontFamily:'helvetica' }}><span style={{color:"#F0B323"}}>Ready to Begin?</span></span>
                            <p class="mt-n2 mb-25 text-center " style={{ fontFamily:'helvetica',color:'#ffffffd4' }}>
                           We’ve built partnerships in <strong>Japan, the Gulf, Russia, and Israel</strong> — and we’re ready to grow with you. Let's take <strong>naturally crafted Indian frozen food</strong> to your country, your label, and your customers. 
                            </p>                            
                        </div>                                                   
                        <h4 class="sec-title text-center mb-30" style={{ fontFamily:'helvetica',color:'#ffffff',textTransform: 'uppercase' }}>Fill B2B Inquiry Form</h4>

                        <form action="mail.php" method="POST" class="booking-form3 ajax-contact" style={{ fontFamily:'helvetica' }}>
                            <div class="row">
                                <div class="form-group col-lg-4 col-md-6">
                                    <input type="text" class="form-control rounded-2" id="name" name="name"
                                        placeholder="Your Name" style={{ fontFamily:'helvetica' }}/>
                                    <i class="far fa-user" style={{color:'#F0B323'}}></i>
                                </div>
                                <div class="form-group col-lg-4 col-md-6">
                                    <input type="tel" class="form-control rounded-2" id="number" name="number"
                                        placeholder="Phone Number" style={{ fontFamily:'helvetica' }} />
                                    <i class="far fa-phone" style={{color:'#F0B323'}}></i>
                                </div>
                                <div class="form-group col-lg-4">
                                    <input type="text" class="form-control rounded-2" id="subject" name="subject"
                                        placeholder="Subject" style={{ fontFamily:'helvetica' }}/>
                                    <i class="far fa-tag" style={{color:'#F0B323'}}></i>
                                </div>
                                <div class="form-group col-12">
                                    <textarea name="message" id="message" cols="30" rows="3" class="form-control rounded-2"
                                        placeholder="Write Message" style={{ fontFamily:'helvetica' }}></textarea>
                                    <i class="far fa-comment" style={{color:'#F0B323'}}></i>
                                </div>
                            </div>
                            {/* <div class="form-btn text-center">
                        <button class="th-btn rounded-2">Send Message<i
                                class="fa-solid fa-arrow-right ms-2"></i></button>
                    </div> */}
                            <div className="text-center">
                                <Link to="/" className="th-btn rounded-2" style={{ fontFamily:'helvetica',background:'#F0B323' }}>Send Message<i className="fa-solid fa-arrow-right ms-2"></i></Link>
                            </div>
                            <p class="form-messages mb-0 mt-3"></p>
                        </form>
                    </div>
                </div>
            </section>  
 





            <br />
        

            <Footer />

        </div>
    );
};

export default Exhibition;
